<template>
    <iframe
        :id="calendarId"
        ref="iframe"
        frameborder="0"
    ></iframe>
</template>

<script>
const MIN_MULTI_CALENDAR_HEIGHT = 262;
const MIN_MULTI_CALENDAR_WIDTH = 320;

export default {
    name: 'OnlineBookingCalendarMulti',
    props: {
        calendarId: String,
        areaId: {
            type: Number,
            default: 0
        },
        websiteUrl: String,
        language: String,
        isPreview: {
            type: Boolean,
            default: false,
        }
    },
    mounted() {
        const iframe = this.$refs.iframe;

        iframe.onload = this.onFrameLoad;
        iframe.parentNode.style.position = 'relative';
        iframe.style.position = 'absolute';
        iframe.style.left = 0;
        iframe.style.top = 0;
        iframe.style.width = MIN_MULTI_CALENDAR_WIDTH + 'px';
        iframe.style.height = MIN_MULTI_CALENDAR_HEIGHT + 'px';
        iframe.style.marginBottom = '0px';
        iframe.src = [
            document.location.origin,
            '/booking-calendar',
            this.isPreview ? '/preview' : '',
            '/websites/', this.websiteUrl,
            '/wpsites/0/categories/', this.areaId,
            '/?iframe=', this.calendarId,
            '&lang=', this.language,
            '&v=', Math.random()
        ].join('');

        window.addEventListener('resize', this.onFrameLoad);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.onFrameLoad);
    },
    methods: {
        onFrameLoad() {
            this.setBookingCalendarWidth();
            this.setBookingCalendarHeight();
        },
        setBookingCalendarWidth() {
            let width = 0;
            const doc = window.document;
            const iframe = this.$refs.iframe;
            const fullscreenElement =
                doc.fullscreenElement ||
                doc.webkitFullscreenElement ||
                doc.mozFullScreenElement ||
                doc.msFullscreenElement;
            if (fullscreenElement && fullscreenElement.id === iframe.id) {
                width = window.screen.width;
            } else {
                const rect = iframe.parentNode.getBoundingClientRect();
                width = rect.width;
            }
            if (width < MIN_MULTI_CALENDAR_WIDTH) {
                width = MIN_MULTI_CALENDAR_WIDTH;
            }
            if (width > 0) {
                iframe.style.width = width + 'px';
                if (iframe.contentWindow) {
                    iframe.contentWindow.postMessage(
                        'width=' + width,
                        document.location.origin
                    );
                }
            }
        },
        setBookingCalendarHeight() {
            const iframe = this.$refs.iframe;
            var height = window.innerHeight - iframe.getBoundingClientRect().top;
            if (height < MIN_MULTI_CALENDAR_HEIGHT) {
                height = MIN_MULTI_CALENDAR_HEIGHT;
            }
            iframe.style.height = height + 'px';
        },
    }
}
</script>

<style lang="scss" scoped>

</style>